import React, { useEffect, useRef, useState } from "react";
import TeamCard from "./team.card.component";
import Marquee from "react-fast-marquee";
import TEAM_DATA from "../../constant/team-data";
import Intro from "../intro/intro.component";
import TrustedCompany from "../company/trusted-company.component";

const Team = () => {

  const sourceDiv = useRef(null);
  const [marqueeTagWidth, setMarqueeTagWidth] = useState(0);

  useEffect(() => {
    if (sourceDiv.current) {
      const sourceDivData = sourceDiv.current.getBoundingClientRect();
      setMarqueeTagWidth(sourceDivData.width);
    }
  }, []);

  return (
    <div className="pt-20 flex flex-col w-full lg:pt-28">
      <div className="flex w-full flex-col lg:gap-20">
        <Intro />
        <TrustedCompany />
      </div>
      <div className="h-24 lg:h-48 flex border-b border-b-greyBg bg-[#0c101c] shadow-custom-inset items-center justify-center">
        <h1
          className="text-4xl lg:text-7xl font-semibold lg:px-0 italic"
          data-aos="fade-up"
          data-aos-duration={1000}
          data-aos-delay={400}
        >
          {"[ { ... C for Coders } ]"}
        </h1>
      </div>
      <div
        className="flex w-full justify-center bg-[#0c101c] pb-8 lg:pb-40 px-4"
        id="team"
      >
        <div
          className="flex w-full border-b border-l lg:max-w-7xl border-r rounded-b-lg lg:rounded-b-3xl items-center justify-center
       border-[#a0a5e2] bg-white/0 backdrop-blur px-2 pb-2 lg:px-6 lg:pb-6"
       
        >
          <div
            className="relative flex w-full before:absolute before:h-full before:w-full before:blur-3xl before:bg-[#9884e6] before:-z-10"
            ref={sourceDiv}
          >
            <div className="flex flex-col lg:flex-row gap-6 w-full items-center justify-between p-3 pt-6 lg:px-14 lg:pt-14 lg:pb-6 rounded-b-lg bg-[#0c101c]">
              <div className="flex gap-10 lg:gap-20 flex-col w-full">
                <div className="">
                  <h1
                    className="text-2xl lg:text-4xl font-bold px-4 lg:px-0"
                    data-aos="fade-up"
                    data-aos-duration={1000}
                    data-aos-delay={400}
                  >
                    Meet Our Backbone
                  </h1>
                </div>
                <div
                style={{
                  maxWidth: `${marqueeTagWidth}px`,
                }}
                className={`flex overflow-hidden`}>
                  <Marquee>
                    {TEAM_DATA.length > 0 &&
                      TEAM_DATA.map((item, index) => (
                        <TeamCard props={item} index={index} />
                      ))}
                  </Marquee>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
